export enum WidgetInputTextFormatType {
  No = 'No',
  FiscalCode = 'FiscalCode',
  VatNumber = 'VatNumber',
  PhoneNumber = 'PhoneNumber'
}
